import * as React from 'react';
import { AuthBrandPanel } from './AuthBrandPanel';
import './auth-layout.css';

export interface AuthLayoutProps {
  children: React.ReactNode;
}

/**
 * Layout wrapper for all authentication pages
 *
 * Desktop: Two-column layout with brand panel (left) and form (right)
 * Mobile: Single column with form only
 *
 * Usage:
 * <AuthLayout>
 *   <AuthCard>
 *     <AuthHeader title="Sign In" />
 *     {form content}
 *   </AuthCard>
 * </AuthLayout>
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  return (
    <div className="auth-layout">
      <AuthBrandPanel />
      <div className="auth-layout-content">
        <div className="auth-layout-content-inner">{children}</div>
      </div>
    </div>
  );
};

AuthLayout.displayName = 'AuthLayout';
